import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
  provideZoneChangeDetection,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { DepositsService } from './services/business/DepositsService';
import { IAffiliatesService } from './services/business/IAffiliatesService';
import { IBusinessService } from './services/business/IBusinessService';
import { IBusinessSummaryService } from './services/business/IBusinessSummaryService';
import { IFileService } from './services/business/IFileService';
import { IInvoiceManager } from './services/business/IInvoiceManager';
import { IProfileManagementService } from './services/business/IProfileManagementService';
import { IPublicService } from './services/business/IPublicService';
import { AffiliatesService } from './services/business/impl/affiliates.service';
import { BusinessSummaryService } from './services/business/impl/business-data.service';
import { FileService } from './services/business/impl/file.service';
import { InvoiceService } from './services/business/impl/invoice.service';
import { KycOnboardingService } from './services/business/impl/kyc-onboarding.service';
import { ProfileManagementService } from './services/business/impl/pofile-management.service';
import { PublicService } from './services/business/impl/public.service';
import { MockAffiliatesService } from './services/business/mock/mock-affiliates.service';
import { MockBusinessSummaryService } from './services/business/mock/mock-business-data.service';
import { MockDepositsService } from './services/business/mock/mock-deposits.service';
import { MockFileService } from './services/business/mock/mock-file.service';
import { MockInvoiceManagerService } from './services/business/mock/mock-invoice.service';
import { MockOnboardingService } from './services/business/mock/mock-onboarding.service';
import { MockProfileManagementService } from './services/business/mock/mock-profile.service';
import { MockPublicService } from './services/business/mock/mock-public.service';
import { SharedProfileData } from './services/data/shared-profile-data';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const sharedAppProviders: (Provider | EnvironmentProviders)[] = [
  SharedProfileData,
  {
    provide: IInvoiceManager,
    useClass: environment.useMock ? MockInvoiceManagerService : InvoiceService,
  },
  {
    provide: IBusinessSummaryService,
    useClass: environment.useMock
      ? MockBusinessSummaryService
      : BusinessSummaryService,
  },
  {
    provide: IProfileManagementService,
    useClass: environment.useMock
      ? MockProfileManagementService
      : ProfileManagementService,
  },
  {
    provide: IBusinessService,
    useClass: environment.useMock
      ? MockOnboardingService
      : KycOnboardingService,
  },
  {
    provide: IPublicService,
    useClass: environment.useMock ? MockPublicService : PublicService,
  },
  {
    provide: 'IDepositsService',
    useClass: environment.useMock ? MockDepositsService : DepositsService,
  },
  {
    provide: IFileService,
    useClass: environment.useMock ? MockFileService : FileService,
  },
  {
    provide: IAffiliatesService,
    useClass: environment.useMock ? MockAffiliatesService : AffiliatesService,
  },
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideHttpClient(withInterceptorsFromDi()),
  importProvidersFrom(
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ),
];
